module.exports = __webpack_public_path__ + "static/media/OfficeBuildingCrop.310cc040.jpg";